import React, { useState } from 'react'
import axios from 'axios'
import { connect } from 'react-redux'
import { showAlertModal } from '../../../../actions'
import { FaEye, FaEyeSlash } from 'react-icons/fa'

const BasicInfo = props => {
  const { 
    devices,
    token,
    userId,
    name,
    handleChange,
    email,
    password,
    userEdit,
    generatePassword,
    setGeneratePassword,
    passwordVisible,
    togglePasswordVisible,
    sendCredentials,
    resetPassword,
    customerId,
    customers,
    showAlertModal,
  } = props

  const API_URL = process.env.REACT_APP_BACKEND
  const [loading, setLoading] = useState(false)

  const sendPasswordReset = async () => {
    setLoading(true)
    await axios({
      method: 'post',
      url: API_URL + 've/resetpassword?device=' + devices[0].sDeviceID,
      headers: {
        'Content-Type': 'Application/json',
        'Authorization': 'Bearer ' + token
      },
      withCredentials: true,
      data: {id: userId},
    })
    .then(response => {
      resetPassword(response.data.password)
      setLoading(false)
      showAlertModal(['SUCCESS', 'Password reset email sent successfully.'])
    })
    .catch( error => {
      console.log(error)
      setLoading(false)
      showAlertModal(['ERROR', 'Password reset failed.'])
    })
  };

  return (
    <div style={{ width: userEdit ? '70%' : '50%', borderRight: '1px solid black' }}>
      <p style={styles.header}>Basic Information</p>

      <div style={styles.row}>
        <p style={styles.label} htmlFor="name">Name <span style={styles.note}>(first last)</span> :</p>
        <input name="name" type="text" style={styles.input} value={name} spellCheck='false' autoComplete={"off"} autoCorrect='off' onChange={(e) => handleChange(e, 'name')} />
      </div>

      <div style={styles.row}>
        <p style={styles.label} htmlFor="email">Email <span style={styles.note}>(login)</span>:</p>
        <input name="email" type="email" style={styles.input} value={email} spellCheck='false' autoComplete={"off"} autoCorrect="off" onChange={(e) => handleChange(e, 'email')} />
      </div>

      <div style={styles.row}>
        <p style={styles.label}>Customer:</p>
        <select value={customerId} onChange={e => handleChange(e, 'customerId')} style={styles.input}>
          <option value={'none'}>None</option>
          {customers && customers.length > 0 && customers.map( c => (
            <option key={c.bID} value={c.bID}>{c.sName}</option>
          ))}
        </select>
      </div>

      {!userEdit &&
        <div style={styles.row}>
          <p style={styles.label}>Password:</p>
          <div style={styles.input}>
            <div>
              <div style={{ marginBottom: '1vmin' }}>
                <input type="radio" name="generate" value={generatePassword} checked={generatePassword} style={styles.checkbox} onChange={(e) => setGeneratePassword(1)} />
                <span>Generate temporary password</span>
              </div>

              <div style={{ marginBottom: '1vmin' }}>
                <input type="radio" name="generate" value={!generatePassword} checked={!generatePassword} style={styles.checkbox} onChange={(e) => setGeneratePassword(0)} />
                <span>Enter a specific password</span>
              </div>

              <div style={{position: 'relative', display: generatePassword ? 'none' : 'block'}}>
                <input type={passwordVisible ? 'text' : 'password'} value={password} onChange={(e) => handleChange(e, 'password')} style={{...styles.input, paddingRight: '1.5vw'}} spellCheck='false' autoComplete={"off"} autoCorrect="off" />
                {passwordVisible
                  ? <FaEye title="Hide Password" style={styles.icon} onClick={togglePasswordVisible} />
                  : <FaEyeSlash title="Show Password" style={styles.icon} onClick={togglePasswordVisible} />
                }
              </div>
            </div>
          </div>        
        </div>
      }

      <div style={styles.row}>
        {userEdit
          ? <button style={{...styles.button, ...(loading && {backgroundColor: 'gray'})}} onClick={loading ? null : sendPasswordReset}>Send Password Reset Email</button>
          : <div style={styles.credentials}>
              <input type="checkbox" checked={sendCredentials} style={styles.checkbox} onChange={(e) => handleChange(e, 'sendCredentials')}/>
              <span >Send credentials to user email on save</span>
            </div>
        }
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  const {devices} = state.data
  const {token} = state.auth
  return {
    devices,
    token,
  }
}
export default connect(mapStateToProps, { showAlertModal } )(BasicInfo)

const styles = {
  header: { margin: 0, marginBottom: '1vmin', fontSize: '1.6vmin', fontWeight: 'bold', textDecoration: "underline" },
  row: { display: 'flex', justifyContent: 'flex-start', marginBottom: '1.6vmin' },
  label: { margin: 0, fontSize: '1.4vmin', width: '50%' },
  note: { fontSize: '1.1vmin', fontStyle: 'italic' },
  icon: { cursor: 'pointer', fontSize: '1.8vmin' , position: 'absolute', top: 2, right: '0.5vmin', width: '1vw', color: 'black', },
  input: { fontSize: '1.4vmin', width: '100%', marginRight: '2%', },
  checkbox: { cursor: 'pointer', height: '1.2vmin', width: '1.2vmin', marginRight: '2vmin'},
  button: {
    cursor: 'pointer',
    marginTop: '1vmin',
    padding: '0.5vmin',
    borderRadius: 5,
  },
  credentials: { display: "flex", alignItems: 'baseline', width: '100%', marginTop: '1vmin', },
}